import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './ContactPage.css';

function ContactPage() {
    const [form, setForm] = useState({
        name: '',
        email: '',
        message: '',
        phone: '',
        isWhatsapp: false,
    });
    const [feedback, setFeedback] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs
            .send('service_bexd4mv', 'template_vmeqbhl', form, 'Rf85DKpohg8T6kGeY')
            .then((response) => {
                console.log('Email enviado com sucesso!', response.status, response.text);
                setFeedback('Recebemos o seu contato e retornaremos em breve!');
                setForm({ name: '', email: '', message: '', phone: '', isWhatsapp: false });
            })
            .catch((err) => {
                console.error('Falha no envio do email:', err);
                setFeedback('Ocorreu um erro ao enviar sua mensagem. Tente novamente mais tarde.');
            });
    };

    return (
        <section className="contact" id="contato">
            <div className="contact-container">
                <h2>Contato</h2>
                {feedback && <p className="feedback">{feedback}</p>}
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Nome"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                        required
                    />
                    <div className="phone-container">
                        <PhoneInput
                            country="br"
                            value={form.phone}
                            onChange={(phone) => setForm({ ...form, phone })}
                            placeholder="Telefone (opcional)"
                            inputProps={{ name: 'phone' }}
                            masks={{ br: '(..) .....-....' }}

                        />
                        <label className="whatsapp-label">
                            <input
                                type="checkbox"
                                name="isWhatsapp"
                                checked={form.isWhatsapp}
                                onChange={handleChange}
                            />
                            WhatsApp
                        </label>
                    </div>
                    <textarea
                        name="message"
                        placeholder="Mensagem"
                        value={form.message}
                        onChange={handleChange}
                        required
                    />
                    <button type="submit">Enviar</button>
                </form>
            </div>
        </section>
    );
}

export default ContactPage;
